export const SET_IS_FETCHING = "SET_IS_FETCHING";

export const GET_STOP_LIST_AGGREGATORS_SAGA = "GET_STOP_LIST_AGGREGATORS_SAGA";

export const GET_SECTION_LIST_SUCCESS = "GET_SECTION_LIST_SUCCESS";
export const GET_SECTION_LIST_ERROR = "GET_SECTION_LIST_ERROR";

export const GET_STOP_LIST_SAGA = "GET_STOP_LIST_SAGA";

export const GET_STOP_LIST_SUCCESS = "GET_STOP_LIST_SUCCESS";

export const SWITCH_STOP_LIST_PRODMODE = "SWITCH_STOP_LIST_PRODMODE";

export const UPDATE_STOP_LISTS = "UPDATE_STOP_LISTS";

export const UPDATE_ALL_STOP_LISTS_SAGA = "UPDATE_ALL_STOP_LISTS_SAGA";

export const GET_PRODUCT_STORES_SUCCESS = "GET_PRODUCT_STORES_SUCCESS";
export const GET_PRODUCT_STORES_SAGA = "GET_PRODUCT_STORES_SAGA";

export const DISABLE_PRODUCT_SAGA = "DISABLE_PRODUCT_SAGA";
export const DISABLE_PRODUCT_BY_PERIOD_SAGA = "DISABLE_PRODUCT_BY_PERIOD_SAGA";

export const ENABLE_PRODUCT_SAGA = "ENABLE_PRODUCT_SAGA";

export const SEARCH_TEXT_CHANGE = "SEARCH_TEXT_CHANGE";

export const FETCH_AGGREGATORS_SUCCESS = "FETCH_AGGREGATORS_SUCCESS";
